import {ReactComponent as Logo} from '@/assets/logo.svg';
import {ReactComponent as LogoPink} from '@/assets/logo_pink.svg';
import {ReactComponent as LogoGreen} from '@/assets/logo_green.svg';
import {ReactComponent as google} from '@/assets/google.svg';
import {ReactComponent as facebook} from '@/assets/facebook.svg';
import {ReactComponent as apple} from '@/assets/apple.svg';
import {ReactComponent as instagram} from '@/assets/instagram.svg';
import {ReactComponent as Show} from '@/assets/show.svg';
import {ReactComponent as UnShow} from '@/assets/unshow.svg';
import {ReactComponent as AddAPhoto} from '@/assets/add_a_photo.svg';
import {ReactComponent as Back} from '@/assets/back.svg';
import {ReactComponent as user} from '@/assets/user.svg';
import {ReactComponent as trash} from '@/assets/trash.svg';
import {ReactComponent as Search} from '@/assets/search.svg';
import {ReactComponent as Select} from '@/assets/select.svg';
import {ReactComponent as Close} from '@/assets/close.svg';
import {ReactComponent as Burger} from '@/assets/burger.svg';
import {ReactComponent as ArrowRight} from '@/assets/arrow_right.svg';
import {ReactComponent as Add} from '@/assets/add.svg';
import {ReactComponent as Sent} from '@/assets/sent.svg';
import {ReactComponent as Readed} from '@/assets/readed.svg';
import {ReactComponent as Send} from '@/assets/send.svg';
import {ReactComponent as SendActive} from '@/assets/send_active.svg';
import {ReactComponent as PreviousPlaces} from '@/assets/previous_places.svg';
import {ReactComponent as Image} from '@/assets/image.svg';
import {ReactComponent as ChevronRight} from '@/assets/chevron_right.svg';
import {ReactComponent as ChevronBottom} from '@/assets/chevron_bottom.svg';
import {ReactComponent as Boll} from '@/assets/boll.svg';
import {ReactComponent as Exp} from '@/assets/exp.svg';
import {ReactComponent as Map} from '@/assets/map.svg';
import {ReactComponent as Share} from '@/assets/share.svg';
import {ReactComponent as GolfHole} from '@/assets/golf_hole.svg';
import {ReactComponent as Star} from '@/assets/star.svg';
import {ReactComponent as Call} from '@/assets/call.svg';
import {ReactComponent as Web} from '@/assets/web.svg';
import {ReactComponent as StarEmpty} from '@/assets/star_empty.svg';
import {ReactComponent as Filter} from '@/assets/filter.svg';
import {ReactComponent as LogOut} from '@/assets/log_out.svg';
import {ReactComponent as Edit} from '@/assets/edit.svg';
import {ReactComponent as MapIcon} from '@/assets/map_icon.svg';
import {ReactComponent as Chat} from '@/assets/chats.svg';
import {ReactComponent as Notification} from '@/assets/notifications.svg';
import {ReactComponent as Profile} from '@/assets/profile.svg';
import {ReactComponent as Home} from '@/assets/home.svg';
import {ReactComponent as Invitation} from '@/assets/invitations.svg';
import {ReactComponent as Plus} from '@/assets/plus.svg';
import {ReactComponent as Minus} from '@/assets/minus.svg';
import {ReactComponent as ShareNormal} from '@/assets/share_normal.svg';

const LazyAssets = {
  Logo,
  LogoPink,
  LogoGreen,
  google,
  facebook,
  apple,
  instagram,
  Show,
  UnShow,
  AddAPhoto,
  Back,
  user,
  trash,
  Search,
  Select,
  Close,
  Burger,
  ArrowRight,
  Add,
  Sent,
  Readed,
  Send,
  SendActive,
  PreviousPlaces,
  Image,
  ChevronRight,
  ChevronBottom,
  Boll,
  Exp,
  Map,
  Share,
  GolfHole,
  Star,
  Call,
  Web,
  StarEmpty,
  Filter,
  LogOut,
  Edit,
  MapIcon,
  Chat,
  Notification,
  Profile,
  Home,
  Invitation,
  Plus,
  Minus,
  ShareNormal
};

export default LazyAssets;